export default "__VITE_ASSET__BCpggGEc__"